import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';

/**
 * @param studFee array|null
 * @returns {*}
 * @constructor
 */
const Standing = ({ studFee }) => {
    if (studFee && studFee.length) {
        const {
            studName,
            countryCode,
        } = studFee[0];

        return (
            <Definition term="Standing">
                <span>{studName} ({countryCode})</span>
            </Definition>
        );
    }
    return null;
};

Standing.propTypes = {
    studFee: PropTypes.arrayOf(PropTypes.shape({
        countryCode: PropTypes.string,
        studName: PropTypes.string,
    })),
};

export default Standing;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Standing.jsx